import React from 'react';

const PrivacyContent = () => (
    <div>
        <h2>Privacy Policy</h2>

        <p>Your privacy is important to us. This Privacy Policy outlines how your personal information is collected, used, and shared when you use our management system.</p>

        <h3>Information We Collect:</h3>
        <p>We collect personal information you provide to us, including but not limited to your name, email address, and contact details. We also collect information about your usage of the system.</p>

        <h3>How We Use Your Information:</h3>
        <p>We use the information we collect to provide and improve the services offered by the system. This includes sending relevant messages via the WhatsApp API and ensuring the security and integrity of the system.</p>

        <h3>Sharing Your Information:</h3>
        <p>We do not sell or share your personal information with third parties without your consent, except as necessary to provide the services or comply with applicable laws.</p>

        <h3>Data Retention:</h3>
        <p>We will retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.</p>

        <h3>Security:</h3>
        <p>We implement security measures to protect your personal information. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>

        <h3>Your Choices:</h3>
        <p>You have the right to access, correct, or delete your personal information. If you have any questions or concerns, please contact us at privacy@example.com.</p>

        <h3>Changes to Privacy Policy:</h3>
        <p>We reserve the right to update or modify this Privacy Policy at any time. Your continued use of the system after any changes to the policy constitutes your acceptance of the updated terms.</p>
    </div>
);

export default PrivacyContent;
